<template>
<footer class="bg-light text-center text-lg-start">
  <!-- Copyright -->
  <p class="text-center p-3" style="background-color: rgb(44, 130, 224);color:white;">
    &copy; 2022 Gym Program Builder
  </p>
  <!-- Copyright -->
</footer>
</template>
<style>

.va-navbar__center{
    display: inline-block;
}

</style>
